import { TenantHookController } from '../domains/Tenant/infrastructure/controllers/Tenant.hook.controller';
import { UserHookController } from '../domains/User/infrastructure/controllers/User.hook.controller';
import { inversifyContainer } from '../inversifyContainer';
import { ReactHookServicePort } from '../shared/core/port/React.hook.service.port';

export class ReactHooksApplication {
  private static instance: ReactHooksApplication;
  public readonly tenantHookController: TenantHookController;

  public readonly userHookController: UserHookController;
  public readonly reactHookServicePort: ReactHookServicePort;

  public readonly unifiedRolesHookController = {
    toComposeUseSaveResourceTenantAgnosticRoles: () => () => [
      {},
      (): never => {
        throw new Error('not implemented');
      },
    ],
  };

  public static getInstance(): ReactHooksApplication {
    if (!ReactHooksApplication.instance) {
      ReactHooksApplication.instance = new ReactHooksApplication();
    }
    return ReactHooksApplication.instance;
  }

  private constructor() {
    this.tenantHookController = inversifyContainer.get(TenantHookController);
    this.userHookController = inversifyContainer.get(UserHookController);
    this.reactHookServicePort = inversifyContainer.get(ReactHookServicePort);
  }
}
